<div
  #publishDatePickerPop="atxPopover"
  [atxPopover]="rangeSelection"
  [popoverPlacement]="placement.BOTTOM_LEFT"
  [popoverEnabled]="!disabled"
  autoClose="outside"
  class="input-group mb-0"
>
  <div class="input-group-prepend">
    <button
      class="btn btn-light border d-flex align-items-center"
      type="button"
      (click)="publishDatePickerPop.open()"
    >
      <fa-icon [icon]="['fas', 'calendar-days']"></fa-icon>
    </button>
  </div>
  <input
    class="form-control"
    [formControl]="inputControl"
    [placeholder]="placeholder"
    type="text"
    autocomplete="off"
    readonly="true"
  />
  @if (allowClear && !!inputControl.value) {
  <div class="input-group-append">
    <button
      class="btn btn-light border d-flex align-items-center"
      type="button"
      (click)="clear(); publishDatePickerPop.close(); $event.stopPropagation()"
    >
      <fa-icon [icon]="['fas', 'trash']"></fa-icon>
    </button>
  </div>
  }
</div>
<ng-template #rangeSelection>
  <atx-date-range-picker
    class="p-2"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [validRanges]="validRanges"
    [displayFooterHandlers]="true"
    [range]="range"
    [rangeBoundary]="rangeBoundary"
    (rangeSelect)="rangeSelected($event); publishDatePickerPop.close()"
    [displayMonths]="1"
    [useResetText]="true"
  >
  </atx-date-range-picker>
</ng-template>
